import axios from "axios";
import { conf } from "../const";

export function fetchData(method, path, data, token) {
  return new Promise(async (resolve) => {
    try {
      let headers = null;
      if (!token) {
        token = JSON.parse(localStorage.getItem(conf.cookieName));
        token = token ? token.access_token : "";
      }
      headers = { Authorization: token };
      let result = await axios({
        method,
        url: conf.endpoint.epayment + path,
        data,
        headers,
      });
      if (result && result.data) resolve(result.data);
      else resolve(null);
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error)
        alert(e.response.data.error.message);
      resolve(null);
    }
  });
}

export function getProfileByToken() {
  return new Promise(async (resolve) => {
    try {
      let cookie = JSON.parse(localStorage.getItem(conf.cookieName));
      let token = cookie.access_token;
      let profile = await axios.get(conf.endpoint.epayment + "/me", {
        headers: {
          Authorization: token,
        },
      });
      profile = profile.data;
      profile.fullname =
        profile.PrenameTha + " " + profile.NameTha + " " + profile.SurNameTha;
      resolve(profile);
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message)
        alert(e.response.data.message);
      resolve(null);
    }
  });
}

export function getPermissionByToken(token) {
  return new Promise(async (resolve) => {
    try {
      if (!token) {
        let cookie = JSON.parse(localStorage.getItem(conf.cookieName));
        token = cookie.access_token;
      }
      let profile = await axios.get(conf.endpoint.epayment + "/permission", {
        headers: {
          Authorization: token,
        },
      });
      if (profile.data && profile.data.usn) {
        let newCookie = {
          profile: profile.data,
          access_token: token,
        };
        localStorage.setItem(conf.cookieName, JSON.stringify(newCookie));
        resolve(profile.data);
      } else {
        window.location = conf.loginCallback;
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message)
        alert(e.response.data.message);
      window.location = conf.loginCallback;
    }
  });
}

export function currentFormat(amount, noDecimal) {
  try {
    if (noDecimal === true) {
      amount = parseFloat(amount).toLocaleString();
    } else {
      amount = parseFloat(amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    return amount;
  } catch (e) {
    return "-";
  }
}
